// imageAttach.js — pure helpers for the agentLoop vision hook. A tool's execute can
// push image data-URLs (video frames, screenshots) via ctx.attachImages; after its
// text result the spine injects them as an image_url user message so a vision-capable
// model SEES them. Kept out of the spine to hold the DP-LOC ratchet.

const MAX_IMAGES = 8;

/** Push only real image data-URLs into the sink (drops non-strings / non-images). */
export function pushImages(sink, urls) {
  if (!Array.isArray(sink) || !Array.isArray(urls)) return;
  for (const u of urls) if (typeof u === 'string' && u.startsWith('data:image')) sink.push(u);
}

/** Build the image_url user message for the collected images, or null when there are none. */
export function imageMessage(toolName, images) {
  if (!Array.isArray(images) || images.length === 0) return null;
  return {
    role: 'user',
    content: [
      { type: 'text', text: `Imagens de ${toolName} (${images.length}) — analise-as:` },
      ...images.slice(0, MAX_IMAGES).map((url) => ({ type: 'image_url', image_url: { url } })),
    ],
  };
}
